<template>
  <basicContainer>
    <div class="yytbgl">
      <!-- 预约填报管理 -->
      <avue-crud
        :data="data"
        :option="option"
        :page.sync="page"
        @on-load="onLoad"
        :search.sync="search"
        @search-change="searchChange"
        @search-reset="searchReset"
        @refresh-change="refreshChange"
      >
      <template v-slot:menu="{type,size,row}">
          <el-button size="small" type="text" icon="el-icon-view" @click.stop="view(row)">查看</el-button>
          <el-button size="small" type="text" icon="el-icon-edit" @click.stop="edit(row)">编辑</el-button>
      </template>
      </avue-crud>
    </div>
  </basicContainer>
</template>

<script>

export default {
  data() {
    return {
      data: [],
      option: {
        dialogDrag: true,
        dialogClickModal: false,
        stripe: true,
        border: true,
        page: true,
        selection: false,
        align: 'left',
        menuAlign: 'center',
        menuWidth: 200,
        searchMenuSpan: 6,
        columnBtn: false,
        refreshBtn: true,
        labelWidth: 150,
        viewBtn: false,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        searchSize: 'medium',
        column: [
          {
            label: '通知公告',
            prop: 'xmBh',
            search: true,
            rules: [{
              required: true,
              message: '请输入项目编号',
              trigger: 'blur'
            }]
          },
          {
            label: '合同编号',
            prop: 'htbh',
            search: true,
            rules: [{
              required: true,
              message: '请输入合同编号',
              trigger: 'blur'
            }]
          },
          // {
          //   label: '合同签订日期',
          //   prop: 'htqd',
          //   search: true,
          //   type: 'daterange',
          //   format: 'yyyy-MM-dd',
          //   valueFormat: 'yyyy-MM-dd',
          //   searchSpan: 12,
          //   searchLabelWidth: 110,
          //   editDisplay: false,
          //   viewDisplay: false
          // },
          {
            label: '合同签订日期',
            prop: 'htqd',
            type: 'date',
            search: true,
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd',
            // searchSpan: 12,
            searchLabelWidth: 110,
            rules: [{
              required: true,
              message: '请输入合同签订日期',
              trigger: 'blur'
            }]

          },
          {
            label: '签约客户',
            prop: 'qykh',
            search: true,
            rules: [{
              required: true,
              message: '请输入签约客户',
              trigger: 'blur'
            }]
          },
          {
            label: '合同名称',
            prop: 'htmc',
            rules: [{
              required: true,
              message: '请输入合同名称',
              trigger: 'blur'
            }]

          },
          {
            label: '客户名称',
            prop: 'khMc',
            search: true,
            rules: [{
              required: true,
              message: '请输入客户名称',
              trigger: 'blur'
            }]
          },
          {
            label: '项目名称',
            prop: 'xmMc',
            rules: [{
              required: true,
              message: '请输入项目名称',
              trigger: 'blur'
            }]

          },
          {
            label: '销售经理',
            prop: 'xs'
          },
          {
            label: '项目负责人',
            prop: 'xmfzr'
          },
          {
            label: '合同总金额',
            prop: 'htje',
            rules: [{
              required: true,
              message: '请输入合同总金额',
              trigger: 'blur'
            }]
          },
          {
            label: '税率',
            prop: 'SFLX'

          },
          {
            label: '税后总金额',
            prop: 'shje'
          },
          {
            label: '回款条件',
            prop: 'hktj',
            width: '300px',
            type: 'textarea'
          },
          {
            label: '开票金额',
            prop: 'kpje'
          },
          {
            label: '发票类型',
            prop: 'fplx'
          },
          {
            label: '不含税开票额',
            prop: 'bhskpe'
          },
          {
            label: '开票日期',
            prop: 'kprq'
          },
          {
            label: '开票总额',
            prop: 'kpze'
          },
          {
            label: '不含开票额',
            prop: 'bhskpe'

          },
          {
            label: '开票比例',
            prop: 'kpbl'

          },
          {
            label: '未开票金额',
            prop: 'wkpje'
          },
          {
            label: '收款金额',
            prop: 'skje'
          },
          {
            label: '收款日期',
            prop: 'skrq'
          },
          {
            label: '收款总额',
            prop: 'skze'
          },
          {
            label: '收款比例',
            prop: 'skbl'
          },
          {
            label: '应收账款',
            prop: 'yszk'
          },
          {
            label: '收款/开票情况',
            prop: 'skqk'
          },
          {
            label: '合同验收日期',
            prop: 'htysrq'
          },
          {
            label: '验收条件',
            prop: 'ystj'
          },
          {
            label: '验收状态',
            prop: 'yszt',
            rules: [{
              required: true,
              message: '请输入验收状态',
              trigger: 'blur'
            }]
          },
          {
            label: '验收报告',
            prop: 'ysbg'
          },
          {
            label: '验收报告日期',
            prop: 'ysbgrq'
          },
          {
            label: '实际验收日期',
            prop: 'sjysrq'
          },
          {
            label: '保证金金额',
            prop: 'bzje'
          },
          {
            label: '保证金支付说明',
            prop: 'bzjsm',
            width: '220px'
          },
          {
            label: '可收回日期',
            prop: 'khsrq'
          },
          {
            label: '是否收回',
            prop: 'sfsh'
          },
          {
            label: '售后期限',
            prop: 'shqx'
          },
          {
            label: '过保日期',
            prop: 'gbrq'
          },
          {
            label: '是否过保',
            prop: 'SFZB'
          },
          {
            label: '售后条款',
            prop: 'shtk'
          },
          {
            label: '合同归档日期',
            prop: 'htgdrq'
          },
          {
            label: '归档人',
            prop: 'gdr'
          },
          {
            label: '更新时间',
            prop: 'updatetime',
            search: true,
            type: 'date',
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd'
          },
          {
            label: '更新人',
            prop: 'username'
          }
        ]
      },
      page: {
        pageSize: 10,
        currentPage: 1,
        pageSizes: [10, 20, 30, 40, 50, 100],
        total: 0
      },
      search: {}
    }
  },
  methods: {
    load(done) {
      this.$http
        .post('/PayMentManage/pay-query', { entity: { ...this.search }}, {
          params: {
            pageNum: this.page.currentPage,
            pageSize: this.page.pageSize

          }
        })
        .then(res => {
          this.data = res.data.records || []
          this.page.total = res.data.total || res.data.records.length || 0
        })
        .catch(error => {
          this.$message.error(error.msg || error.message)
        })
        .finally(() => {
          typeof done === 'function' && done()
        })
    },
    onLoad(page) {
      this.page.currentPage = page.currentPage
      this.page.pageSize = page.pageSize
      this.load()
    },
    searchChange(params, done) {
      if (params.htqd !== undefined) {
        params.htqd = params.htqd.toString()
      }

      if (params.updatetime !== undefined) {
        params.updatetime = params.updatetime.toString()
      }
      this.search = params
      this.page.currentPage = 1
      this.load(done)
    },
    searchReset() {
      this.search = {}
      this.page.currentPage = 1
      this.load()
    },
    refreshChange() {
      this.load()
    },

    edit(row) {
      row.businessKey = row.id
      this.$router.push({
        name: 'workFlow-view-myApply',
        query: {
          businessKey: row.businessKey,
          processInstanceId: null,
          taskId: null,
          formId: 'caef7b7d7b2844fb90fbd02dff8fc1a2',
          pageKey: 'DO'
        }
      })
    },

    view(row) {
      row.businessKey = row.id
      this.$router.push({
        name: 'workFlow-view-myApply',
        query: {
          businessKey: row.businessKey,
          processInstanceId: null,
          taskId: null,
          formId: 'caef7b7d7b2844fb90fbd02dff8fc1a2',
          pageKey: 'VIEW'
        }
      })
    }

  }
}
</script>

<style></style>
